import React from "react";
import { Tag,Tooltip } from "antd";
import { appHelper } from "../common/helper";

const TeamsTag = ({ teamData, border = true,padding }) => {
const {truncateByLength} = appHelper();
  
  return (
    <div
      style={{
        display: "inline-flex",
        gap: "4px",
        flexWrap: "wrap",
        padding: padding === false ? "2px -1px 2px 8px" : "2px 40px 2px 8px",

        border: border ? "2px solid #E8E8E8" : "none",
        borderRadius: "8px",
      }}
    >
      {Object.entries(teamData).map(([team, info]) => {
        if (!info?.role_name) return null;

        return (
          <Tag
            key={team}
            style={{
              backgroundColor: "#FFFFFF",
              color: "#5E5E5E",
              fontSize: "10px",
              fontWeight: "600",
              borderRadius: "4px",
              padding: "4px 6px",
              border: "1px solid #E2E2E2",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              margin: "4px",
              height: "20px",
            }}
          >
            <span
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: info.color,
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>
           <Tooltip title={`${info.name}: ${info.role_name}`}>
              <span>
             {truncateByLength(info.name,12)} : {truncateByLength(info.role_name,12)}
             </span>
             </Tooltip>
          </Tag>
        );
      })}
    </div>
  );
};

export default TeamsTag;
